import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";

export default function ReactVideoPlayer(props) {
  const playerRef = useRef(null);

  if (playerRef.current) {
  }

  return (
    <>
      <ReactPlayer
        ref={playerRef}
        url={props.src}
        playing={!!props.autoplay}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded youtube"
        playsinline={true}
        width={"100%"}
        height={props.height ? props.height : "100%"}
        controls={true}
        // pip={true}
        progressInterval={30000}
        onStart={() => {
          // props.handlePlaybackStart(
          //   playerRef?.current?.getInternalPlayer()?.getVideoUrl(),
          //   playerRef?.current?.getDuration()
          // );
        }}
        onEnded={() => {
          props.handlePlaybackEnd(
            playerRef?.current?.getInternalPlayer()?.getVideoUrl(),
            playerRef?.current?.getDuration()
          );
        }}
        onPlay={() => {
          props.handlePlaybackStart(
            playerRef?.current?.getInternalPlayer()?.getVideoUrl(),
            playerRef?.current?.getDuration()
          );
        }}
        onProgress={(e) => {
          props.handlePlaybackProgress(
            playerRef?.current?.getInternalPlayer()?.getVideoUrl(),
            playerRef?.current?.getDuration()
          );
        }}
        onSeek={() => {
          console.log("video playback Seeked");
        }}
        config={{
          youtube: {
            playerVars: {
              enablejsapi: 1,
              autoplay: props.autoplay ? 1 : 0,
              rel: 0,
              modestbranding: 1,
              playsinline: 1,
              hl: props.languageCode,
            },
            embedOptions: {},
          },
        }}
        style={{
          // position: "absolute",
          top: props.top ? props.top : "0",
          // left: "0",
          // width: "100%",
          height: props.height ? props.height : "100%",
          // zIndex: "-99",
          // pointerEvents: "none",
        }}
      />
    </>
  );
}
